<template>
  <div class="sezione infografiche"  >

    
  <div class="row" >   
    <div class="col s12 m8 offset-m2 yo-align-center ">
      <a href="https://simgeped.it/"><img src="../assets/logo.png" style="width:100%;max-width:400px;"/> </a>
      <h2>Diventa socio</h2>
    </div>
  </div>


<div class="title_h1 yo-color-primary" style="margin-top:30px;">RICHIESTA DI ISCRIZIONE ANNULLATA</div>
<br />
Magari deciderai di registrarti la prossima volta
<br />
Grazie per l'interesse
<br />
La segreteria
   



  </div>
</template>

<script>
export default {
}
</script>


<style scoped>
  .home{
    background:#fff;
    min-height:600px;
    padding:20px;
  }
</style>
